import * as gqlb from "gql-query-builder";

export const LIST_SUBSIDIARIES = gqlb.query({
  operation: "listSubsidiaries",
  fields: [
    {
      operation: "paginatorInfo",
      fields: [
        "count",
        "currentPage",
        "firstItem",
        "hasMorePages",
        "lastItem",
        "lastPage",
        "perPage",
        "total",
      ],
      variables: {},
    },
    {
      operation: "data",
      fields: ["id", "code", "name", "active"],
      variables: {},
    },
  ],
  variables: {
    page: {
      type: "Int",
    },
    first: {
      type: "Int",
    },
  },
});

export const SAVE_SUBSIDIARY = gqlb.mutation({
  operation: "saveSubsidiary",
  fields: ["id", "code", "name"],
  variables: {
    input: {
      type: "SubsidiaryInput",
      required: true,
    },
  },
});
